import AccommodationForm from '@/pages/Accommodations/AccommodationForm';
import AccommodationImages from '@/pages/Accommodations/AccommodationImages';
import AccommodationRoomForm from '@/pages/Accommodations/AccommodationRoomForm';
import AccommodationRooms from '@/pages/Accommodations/AccommodationRooms';
import Accommodations from '@/pages/Accommodations/Accommodations';
import BookingForm from '@/pages/Bookings/BookingForm';
import Bookings from '@/pages/Bookings/Bookings';
import CommercialChainForm from '@/pages/CommercialChains/CommercialChainForm';
import CommercialChains from '@/pages/CommercialChains/CommercialChains';
import Dashboard from '@/pages/Dashboard';
import InvoiceForm from '@/pages/Invoices/InvoiceForm';
import Invoices from '@/pages/Invoices/Invoices';
import Login from '@/pages/Login';
import UserForm from '@/pages/Users/UserForm';
import Users from '@/pages/Users/Users';
import Sales from '@/pages/Sales/Sales';
import SaleForm from '@/pages/Sales/SaleForm';
import SaleCategoryForm from '@/pages/Sales/SaleCategoryForm';
import store from '@/store';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/accommodations',
      name: 'Alojamientos',
      component: Accommodations,
    },
    {
      path: '/accommodations/create',
      name: 'Nuevo alojamiento',
      component: AccommodationForm,
    },
    {
      path: '/accommodations/:id/edit',
      name: 'Editando alojamiento',
      component: AccommodationForm,
    },
    {
      path: '/accommodations/:accommodationId/images',
      name: 'Gestión de imágenes del apartamento',
      component: AccommodationImages,
    },
    {
      path: '/accommodations/:accommodationId/rooms',
      name: 'Gestión de las habitaciones del apartamento',
      component: AccommodationRooms,
    },
    {
      path: '/accommodations/:accommodationId/rooms/create',
      name: 'Nueva habitación',
      component: AccommodationRoomForm,
    },
    {
      path: '/accommodations/:accommodationId/rooms/:id/edit',
      name: 'Editando habitación',
      component: AccommodationRoomForm,
    },
    {
      path: '/accommodations/:accommodationId/rooms/:id/duplicate',
      name: 'Nueva habitación (copia)',
      component: AccommodationRoomForm,
    },
    {
      path: '/bookings',
      name: 'Reservas',
      component: Bookings,
    },
    {
      path: '/bookings/create',
      name: 'Nueva reserva',
      component: BookingForm,
    },
    {
      path: '/bookings/:id/edit',
      name: 'Editando reserva',
      component: BookingForm,
    },
    {
      path: '/bookings',
      name: 'Bookings',
      component: Bookings,
    },
    {
      path: '/invoices',
      name: 'Facturas',
      component: Invoices,
    },
    {
      path: '/invoices/create',
      name: 'Nueva factura',
      component: InvoiceForm,
    },
    {
      path: '/invoices/:id/edit',
      name: 'Editando factura',
      component: InvoiceForm,
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
    },
    {
      path: '/users/create',
      name: 'Creando nuevo usuario',
      component: UserForm,
    },
    {
      path: '/users/:id/edit',
      name: 'Editando usuario',
      component: UserForm,
    },
    {
      path: '/commercial_chains',
      name: 'Grupos de agencias',
      component: CommercialChains,
    },
    {
      path: '/commercial_chains/create',
      name: 'Nuevo grupo de agencias',
      component: CommercialChainForm,
    },
    {
      path: '/commercial_chains/:id/edit',
      name: 'Editar grupo de agencias',
      component: CommercialChainForm,
    },
    {
      path: '/sales',
      name: 'Ofertas',
      component: Sales,
    },
    {
      path: '/sales/create',
      name: 'Nueva oferta',
      component: SaleForm,
    },
    {
      path: '/sales/:id/edit',
      name: 'Editar oferta',
      component: SaleForm,
    },
    {
      path: '/sales_categories/create',
      name: 'Nueva categoría',
      component: SaleCategoryForm,
    },
    {
      path: '/sales_categories/:id/edit',
      name: 'Editar categoría',
      component: SaleCategoryForm,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    { path: '*', redirect: '/' },
  ],
});

router.beforeEach((to, _, next) => {
  if (!store.state.user.authenticated && to.name !== 'Login') {
    store.commit('setRedirection', to.path);
    return next({ name: 'Login' });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js